export default "__VITE_PUBLIC_ASSET__18c16307__"